import Card from 'components/atoms/Card/Card';
import LoadingIndicatorSmall from 'components/atoms/LoadingIndicator/LoadingIndicatorSmall';
import React, { Suspense } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { ReferralsSummaryCardQuery } from './__generated__/ReferralsSummaryCardQuery.graphql';
import classes from './Dashboard.module.scss';
import { SummaryCard } from './SummaryCard.qmee';

export interface Props {
  linkTo: string;
  currency: string;
}

const referralsSummaryCardQuery = graphql`
  query ReferralsSummaryCardQuery {
    referralHistory {
      currentMonth {
        earnings {
          subUnitAmount
        }
      }
    }
  }
`;

// referralHistory is known to be a slow query. It's isolated here, behind its
// own Suspense boundary, so a slow response doesn't delay the rest of the
// dashboard (see useDashboardQuery.ts).
function ReferralsSummaryCardContent({ linkTo, currency }: Props) {
  const data = useLazyLoadQuery<ReferralsSummaryCardQuery>(
    referralsSummaryCardQuery,
    {},
    { fetchPolicy: 'store-or-network' },
  );

  const earnings = data.referralHistory.currentMonth.earnings;

  return (
    <SummaryCard
      title="Referrals"
      linkTo={linkTo}
      current={{
        amount: earnings ? earnings.subUnitAmount / 100 : 0,
        currency,
      }}
    />
  );
}

function ReferralsSummaryCardFallback() {
  return (
    <Card className={classes.summaryCard}>
      <div className={classes.summaryCardTitleRow}>
        <span className={classes.summaryTitle}>Referrals</span>
      </div>
      <LoadingIndicatorSmall ariaLabel="Loading referral earnings" />
    </Card>
  );
}

const ReferralsSummaryCard: React.FC<Props> = (props) => {
  return (
    <Suspense fallback={<ReferralsSummaryCardFallback />}>
      <ReferralsSummaryCardContent {...props} />
    </Suspense>
  );
};

export default ReferralsSummaryCard;
